import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule, TranslateLangPipe } from '@gs-2.0/shared';

import { PortalSharedModule } from '../../_shared/shared.module';
import { GrantComponentsModule } from './grant-components.module';
import { GrantRoutingModule } from './grant-routing.module';
import { GrantComponent } from './grant/grant.component';

@NgModule({
  imports: [
    CommonModule,
    GrantRoutingModule,
    PortalSharedModule,
    SharedModule,
    TranslateLangPipe,
    GrantComponentsModule,
  ],
  declarations: [GrantComponent],
})
export class GrantModule {}
